export default __webpack_public_path__ + "40b0847bfd33cc01922c9327d0e80c35.jpeg";